/**
 * Tenant API URL resolution (AC-25).
 *
 * Runtime API host comes from AuthService/StorageService `baseUrl` (set at login /
 * StartupService), not from `environment.baseUrl` (central company lookup only).
 * Relative app paths are prefixed with `{baseUrl}/api`.
 */
export function resolveTenantApiUrl(baseUrl: string | null | undefined, pathOrUrl: string): string {
  if (!pathOrUrl) {
    return pathOrUrl;
  }
  if (/^https?:\/\//i.test(pathOrUrl)) {
    return pathOrUrl;
  }
  const base = (baseUrl || '').replace(/\/+$/, '');
  const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
  return `${base}/api${path}`;
}
